const Constants = {
  Poll: {
    MULTI_CHOICE_TYPE: 'MC',
    ANONYMOUS_POLL_TYPE: 'IPC'
  },
  Group: {
    GROUP_ADMIN: 'GROUP_ADMIN',
    GROUP_MEMBER: 'GROUP_MEMBER'
  },
  MemberRequestStatus: {
    NOT_FOUND: 'NOT_FOUND',
    PENDING: 'PENDING',
    REJECTED: 'REJECTED'
  }
}

export default Constants



// WEBPACK FOOTER //
// ./src/Constants.js